import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "register-area pt-120 mb-120" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-lg-12" }
const _hoisted_5 = { class: "form-wrapper" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "form-title" }, [
  /*#__PURE__*/_createElementVNode("h3", null, "Employer Free Trial"),
  /*#__PURE__*/_createElementVNode("span")
], -1)
const _hoisted_7 = { class: "register-tab" }
const _hoisted_8 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-12" }
const _hoisted_11 = { class: "form-inner mb-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { for: "first_tname" }, "Name*", -1)
const _hoisted_13 = { class: "input-area" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/user-2.svg",
  alt: ""
}, null, -1)
const _hoisted_15 = ["rules"]
const _hoisted_16 = { class: "col-md-12" }
const _hoisted_17 = { class: "form-inner mb-25" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "company_name" }, "Company Name*", -1)
const _hoisted_19 = { class: "input-area" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/company-2.svg",
  alt: ""
}, null, -1)
const _hoisted_21 = ["rules"]
const _hoisted_22 = { class: "col-md-12" }
const _hoisted_23 = { class: "form-inner mb-25" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email*", -1)
const _hoisted_25 = { class: "input-area" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("img", {
  src: "assets/images/icon/email-2.svg",
  alt: ""
}, null, -1)
const _hoisted_27 = ["rules"]
const _hoisted_28 = /*#__PURE__*/_createStaticVNode("<div class=\"col-md-12\"><div class=\"form-agreement form-inner d-flex justify-content-between flex-wrap\"><div class=\"form-group two\"><input type=\"checkbox\" id=\"html\"><label for=\"html\">By registering, you acknowledge and agree to our Privacy Policy.</label></div></div></div><div class=\"col-md-12\" id=\"form-error\"></div>", 2)
const _hoisted_30 = { class: "col-md-12" }
const _hoisted_31 = { class: "form-inner" }
const _hoisted_32 = {
  key: 1,
  class: "primry-btn-2",
  type: "button"
}
const _hoisted_33 = /*#__PURE__*/_createElementVNode("span", { class: "me-3 fs-6 text-white" }, "Processing...", -1)
const _hoisted_34 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-spinner fa-spin text-white",
  style: {"font-size":"24px"}
}, null, -1)
const _hoisted_35 = [
  _hoisted_33,
  _hoisted_34
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _createElementVNode("form", {
                    onSubmit: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.freeTrial()), ["prevent"]))
                  }, [
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", _hoisted_11, [
                          _hoisted_12,
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _withDirectives(_createElementVNode("input", {
                              name: "first_name",
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.employerForm.name) = $event)),
                              type: "text",
                              id: "first_name",
                              placeholder: "Mr. Robert",
                              rules: _ctx.name
                            }, null, 8, _hoisted_15), [
                              [_vModelText, _ctx.employerForm.name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_16, [
                        _createElementVNode("div", _hoisted_17, [
                          _hoisted_18,
                          _createElementVNode("div", _hoisted_19, [
                            _hoisted_20,
                            _withDirectives(_createElementVNode("input", {
                              name: "company_name",
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.employerForm.company_name) = $event)),
                              type: "text",
                              id: "company_name",
                              placeholder: "Mr. Robert",
                              rules: _ctx.companyName
                            }, null, 8, _hoisted_21), [
                              [_vModelText, _ctx.employerForm.company_name]
                            ])
                          ])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _createElementVNode("div", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("div", _hoisted_25, [
                            _hoisted_26,
                            _withDirectives(_createElementVNode("input", {
                              name: "email",
                              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.employerForm.email) = $event)),
                              type: "email",
                              id: "email",
                              placeholder: "robert@gmail.com",
                              rules: _ctx.validateEmail
                            }, null, 8, _hoisted_27), [
                              [_vModelText, _ctx.employerForm.email]
                            ])
                          ])
                        ])
                      ]),
                      _hoisted_28,
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("div", _hoisted_31, [
                          (!_ctx.isLoading)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.freeTrial && _ctx.freeTrial(...args))),
                                class: "primry-btn-2",
                                type: "button"
                              }, "Subscribe for demo trial"))
                            : (_openBlock(), _createElementBlock("button", _hoisted_32, _hoisted_35))
                        ])
                      ])
                    ])
                  ], 32)
                ])
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}